export default {
      id: "reference-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#reference-usage",
      toString: function () {
        return this.url;
      }
    }